<div class="disney-supplements" *ngIf="supplements.length > 0">
  <div class="disney-supplements__label">
    <p>Paquetes opcionales para estas habitaciones:</p>
  </div>
  <div class="disney-supplements__badge-container">
    <div
      class="disney-supplements__badge-container__badge"
      *ngFor="let badge of supplements"
    >
      <mb-icon-text>
        <mb-icon icon="{{ badge.icon }}"></mb-icon>
        <span>{{ badge.label }}</span>
      </mb-icon-text>
    </div>
  </div>
</div>
